import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { studentRatings } from "../../api/endpoints/students/rateing";
import { tutorsRatings } from "../../api/endpoints/tutors/rateing";
import RatingModal from "./RatingModal.";
import { useNavigate } from "react-router-dom";
export default function RatingModalWrap() {
  const LocalBasePath = "page.rating";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isStu, setIsStu] = useState<boolean>(false);
  const [name, setName] = useState<string | null>(null);
  const [id, setId] = useState<string | null>(null);
  const [sessionNumber, setSessionNumber] = useState<string | null>(null);

  const values = ["good", "neutral", "bad"];
  const navigate = useNavigate();
  const touterOptions = [
    {
      id: 1,
      question: t("q1"),
      key: "connection_quality",
      val: values[1],
    },
  ];
  const stuOptions = [
    {
      id: 1,
      question: t("q1"),
      key: "connection_quality",
      val: values[1],
    },
    {
      id: 2,
      question: t("q2"),
      key: "comprehension_level",
      val: values[1],
    },
    {
      id: 3,
      question: t("q3"),
      key: "tutor_performance",
      val: values[1],
    },
  ];
  useEffect(() => {
    getUrlParameter();
  }, [window.location.pathname]);
  function getUrlParameter() {
    const searchParams = new URLSearchParams(window.location.search);
    const urlSessionId = searchParams.get("sessionId");
    const urlSessionNumber = searchParams.get("sessionNumber");
    const urlStuName = searchParams.get("studentName");
    const urlTouterName = searchParams.get("touterName");
    if (!!urlSessionId && (!!urlStuName || !!urlTouterName)) {
      setIsOpen(true);
      setId(urlSessionId);
      setSessionNumber(urlSessionNumber);
      setIsStu(!!urlStuName);
      setName(!!urlStuName ? urlStuName : urlTouterName);
    }
  }
  const onClose = () => {
    const url = window.location.pathname;
    setIsOpen(false);
    navigate(url);
  };
  return (
    <RatingModal
      options={isStu ? stuOptions : touterOptions}
      isOpen={isOpen}
      userName={name!}
      id={id!}
      sessionNumber={sessionNumber}
      onClose={() => onClose()}
      onSubmit={isStu ? studentRatings : tutorsRatings}
      values={values}
    />
  );
}
